import CheckIcon from '@mui/icons-material/Check';
import MuiCheckbox from '@mui/material/Checkbox';
import { styled } from '@mui/material/styles';
import React from 'react';

const StyledCheckbox = styled(MuiCheckbox)(({ theme }) => ({
  padding: 0,
  width: 20,
  height: 20,
  borderRadius: theme.borderRadius.sm,
  border: `1px solid ${theme.palette.checkbox.border}`,
  backgroundColor: theme.palette.common.white,
  transition: theme.transitions.custom.fast,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.primary.main,
  '&:hover': {
    backgroundColor: theme.palette.checkbox.hoverBg,
    borderColor: theme.palette.checkbox.border,
  },
  '&.Mui-checked': {
    backgroundColor: theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 16,
  },
  '&.Mui-disabled': {
    opacity: 0.5,
  },
}));

interface CheckboxProps {
  checked: boolean;
  onChange: (_event: React.ChangeEvent<HTMLInputElement>, _checked: boolean) => void;
  [key: string]: any;
}

const Checkbox: React.FC<CheckboxProps> = React.memo(function Checkbox({
  checked,
  onChange,
  ...props
}) {
  return (
    <StyledCheckbox
      checked={checked}
      onChange={onChange}
      icon={<span />}
      checkedIcon={<CheckIcon />}
      {...props}
    />
  );
});

export default Checkbox;
